import { Routes } from "@angular/router";
import { WorkflowEndcustomerOneAvailabilityComponent } from "./workflow-endcustomer-one-availability.component";

export const workflowEndcustomerOneAvailabilityRouting: Routes = [
    {
        path: 'availability/:aid', component: WorkflowEndcustomerOneAvailabilityComponent, children: [
            { path: 'contact-sales', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'select', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'address', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'payment', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'checkout', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'complete', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: 'downgrade', component: WorkflowEndcustomerOneAvailabilityComponent },
            { path: '', redirectTo: 'select', pathMatch: 'full' },
        ]
    },
]
